var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"el-zoom-in-center"}},[_c('div',{staticClass:"bg-contain common-blue-contain"},[_c('div',{staticClass:"breadcrumb-tilte"},[_vm._v(_vm._s(_vm.$t('DataRecord'))+" > "+_vm._s(_vm.$t('BatteryPowerrecord')))]),_c('Battery',{attrs:{"userId":_vm.userId}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }